import { Component, OnInit, OnDestroy } from '@angular/core';
import {Location} from '@angular/common';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {News,NewsService } from './news.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'ng2-meta';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  add_date:string;
  news_title:string;
  
  
}

let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.news)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={templateUrl: './pg/news/newsdetail.component.html'}
}
else
{
   componentdata={template: '<div></div>'}

   
}
@Component(componentdata)


/*
@Component({
	//template: require('./newsdetail.component.html')
	templateUrl: './pg/news/newsdetail.component.html'
})*/

export class NewsDetailComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public news:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _location:Location,
	    private metaService: MetaService,
	    private _pageService: NewsService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: '',
                  news_title:'',
                  add_date:''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			this.category=slug;
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);			   
			   this._pageService.getNewsdetail(slug).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                             
                  if(data.news_detail.meta_title)
                  {
	                  this._title.setTitle(data.news_detail.news_title);
					  this.metaService.setTag('og:title',data.news_detail.meta_title); 
                  }
                  
                  else
                  {
                      this._title.setTitle(data.news_detail.news_title); 
	                  this.metaService.setTag('og:title',data.news_detail.news_title);
                  }
                    
                  // console.log(data.data.news_detail);                
                  this.pagedata.news_title=data.news_detail.news_title;  
                  this.pagedata.description=data.news_detail.news_description;  
                  this.pagedata.add_date=data.news_detail.add_date; 
                  
                  
                  this.metaService.setTag('description',data.news_detail.meta_description);                   
                  this.metaService.setTag('keywords',data.news_detail.meta_keywords);

                 // if(data.menu.meta_description)
                   //this.metaService.setTag('description',data.menu.meta_);                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);              
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }
    
    backClicked() {
    
        this._location.back();
    }


}


// WEBPACK FOOTER //
// ./resources/assets/typescript/news/newsdetail.component.ts